"use client";

import { Tabs as ChakraTabs } from "@chakra-ui/react";
import React from "react";

export interface TabsProps {
  items: { label: any; value: string; permission?: string | string[]; testId?: string }[];
  value?: any;
  unmountOnExit?: boolean;
  children: React.ReactNode;
}

export const Tabs = React.forwardRef<HTMLDivElement, TabsProps>(function Tabs(
  { items, value, children, unmountOnExit = true },
  ref
) {
  if (!items || items.length === 0) {
    return <div>No tabs available</div>;
  }

  return (
    <ChakraTabs.RootProvider
      value={value}
      ref={ref}
      lazyMount={true}
      unmountOnExit={unmountOnExit}
      variant={"outline"}
      display="flex"
      flexDirection={"column"}
      flex={100}
      fitted
    >
      <ChakraTabs.List>
        {items.map((tab) => (
          <ChakraTabs.Trigger
            key={tab.value}
            value={tab.value}
            color={"secondary.fg"}
            textStyle="heading.tab"
            data-testid={tab.testId}
          >
            {tab.label}
          </ChakraTabs.Trigger>
        ))}
        {/* <ChakraTabs.Indicator /> */}
      </ChakraTabs.List>
      {children}
    </ChakraTabs.RootProvider>
  );
});

interface TabContentProps {
  value: string;
  children: React.ReactNode;
}

// value in the TabContent should be the same as the value in the Tab
export const TabContent: React.FC<TabContentProps> = ({ value, children }) => {
  return (
    <ChakraTabs.Content
      value={value}
      borderColor={"border"}
      borderBottomWidth={"1px"}
      borderRightWidth={"1px"}
      borderLeftWidth={"1px"}
      borderBottomLeftRadius={"md"}
      borderBottomRightRadius={"md"}
      flex={100}
      p={5}
    >
      {children}
    </ChakraTabs.Content>
  );
};
